export const ERRORS = {
  couldNotCloseIssue: 'Could not close issue',
  couldNotReOpenIssue: 'Could not reopen issue',
}
